import React, { FC } from 'react';
import { SkeletonBrick, Text } from '@carnica/ui-kit';
import { useIsDesktopDimension, useIsMobileDimension } from '@carnica/utils/hooks';
import classNames from 'classnames/bind';
import { AvatarGroupDefaultItem } from '@carnica/ui-kit/types';
import { withRenderFlag } from '@beef/react';
import { cnComponentsTheme } from '@carnica/ui-kit/styles';

import { IconList } from 'components/IconList';

import styles from './styles.pcss';

export type OrangeComboBannerProps = {
  action: string;
  isMobile?: boolean;
  isPending: boolean;
  logos: AvatarGroupDefaultItem;
  onClick: (value: boolean) => void;
  showSkeleton?: boolean;
  title: string;
  url: string;
};

const cn = classNames.bind(styles);

export const _OrangeComboBanner: FC<OrangeComboBannerProps> = ({
  title = '',
  logos = [],
  action = '',
  url = '',
  onClick,
  isPending,
  showSkeleton = false,
  isMobile,
}) => {
  const isMobileDimention = useIsMobileDimension();
  const isDesktop = useIsDesktopDimension();
  const textSize = isMobile || isMobileDimention ? 'caption-medium' : 'body-small';
  const theme = cnComponentsTheme('light');

  const handleBannerClick = (e: React.MouseEvent<HTMLElement>) => {
    if (isDesktop) {
      e.preventDefault();
      onClick(true);
    }
  };

  if (isPending && showSkeleton) {
    return (
      <div className={cn('skeleton', 'block')}>
        <SkeletonBrick className={cn('line')} height={40} width="100%" />
      </div>
    );
  }

  return (
    <a className={cn('link')} href={url} onClick={handleBannerClick}>
      <div className={cn(theme, 'wrapper')}>
        <div className={cn('main')}>
          <Text color="primary-invert" variant={textSize}>
            {title}
          </Text>
          <IconList logos={logos} />
        </div>
        <Text className={cn('action')} color="primary-invert" variant={textSize}>
          {action}
        </Text>
      </div>
    </a>
  );
};

export const OrangeComboBanner: FC<
  {
    shouldRender: boolean;
  } & OrangeComboBannerProps
> = withRenderFlag(_OrangeComboBanner);
